import { createContext, useContext, type ReactNode } from "react";

export interface ApiContext<T> {
  Provider(props: { value: T; children: ReactNode }): ReactNode;
  useApi(): T;
}

/**
 * Cada domínio expõe sua API pública por um contexto próprio. Nenhuma feature
 * alcança os internals de outra: a integração acontece por este contrato.
 */
export function createApiContext<T>(name: string): ApiContext<T> {
  const Context = createContext<T | null>(null);
  return {
    Provider({ value, children }) {
      return <Context.Provider value={value}>{children}</Context.Provider>;
    },
    useApi() {
      const api = useContext(Context);
      if (api === null) throw new Error(`${name}ApiProvider ausente`);
      return api;
    },
  };
}
